import { useEffect } from 'react'
import { DadosContainerDefault } from '../../components/Styles'
import PlanoAcao from '../../components/PlanoAcao'

function PlanoAcaoPage() {

  useEffect(() => {
    document.title = 'Plano de Ação | Gesttor'
  })

  return (
    <DadosContainerDefault>
      <PlanoAcao />
    </DadosContainerDefault>
  )
}

export default PlanoAcaoPage